module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4wOTA5MSAxMC4yODM2TDEuMjcyNzMgNi4yMDg5NkwwIDcuNTY3MTZMNS4wOTA5MSAxM0wxNiAxLjM1ODIxTDE0LjcyNzMgMEw1LjA5MDkxIDEwLjI4MzZaIiBmaWxsPSJ3aGl0ZSIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/learning/course-check-icon.svg
// module id = 720
// module chunks = 0